import { getCorrelationId } from "./correlation";

type logLevel = "info" | "warn" | "error";

interface LogEntry {
  level: logLevel;
  message: string;
  timestamp: string;
  correlationId?: string;
  meta?: Record<string, any>;
  context?: string;
}

class FrontendMoncvproLogger {
  private endpoint = "api/logs";
  private buffer: LogEntry[] = [];
  private flushInterval: ReturnType<typeof setInterval> | null = null;

  private createEntry(
    level: logLevel,
    message: string,
    context?: string,
    meta?: Record<string, any>,
  ) {
    return {
      level,
      message,
      context,
      meta,
      timestamp: new Date().toISOString(),
      correlationId: getCorrelationId(),
    };
  }

  private async flush() {
    if (!this.buffer.length) return;
    const toSend = [...this.buffer];
    this.buffer = [];
    if (this.flushInterval) {
      clearTimeout(this.flushInterval);
      this.flushInterval = null;
    }
    try {
      await fetch(this.endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ logs: toSend }),
      });
    } catch {}
  }

  private scheduleFlush() {
    if (this.flushInterval) return;
    this.flushInterval = setTimeout(() => this.flush(), 5000);
  }

  private addToBuffer(entry: LogEntry) {
    if (process.env.NODE_ENV !== "production") {
      // console[entry.level](entry.message, entry.context, entry.meta);
    }
    this.buffer.push(entry);
    this.scheduleFlush();
  }

  info(message: string, context?: string, meta?: Record<string, any>) {
    this.addToBuffer(this.createEntry("info", message, context, meta));
  }

  warn(message: string, context?: string, meta?: Record<string, any>) {
    this.addToBuffer(this.createEntry("warn", message, context, meta));
  }

  error(message: string, error: Error, context?: string) {
    this.addToBuffer(
      this.createEntry("error", message, context, {
        errorName: error.name,
        stack: error.stack,
      }),
    );
    this.flush();
  }
}

export const logger = new FrontendMoncvproLogger();
